import React, { useState } from 'react';
import './ExhibitionTable.css';

const ExhibitionTable = ({ exhibitions, onDelete, onEdit, loading }) => {
  const [deletingId, setDeletingId] = useState(null);

  const handleDelete = async (exhibitionId, exhibitionName) => {
    if (window.confirm(`Are you sure you want to delete "${exhibitionName}"?`)) {
      setDeletingId(exhibitionId);
      try {
        await onDelete(exhibitionId);
      } finally {
        setDeletingId(null);
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return 'N/A';
    return timeString;
  };

  const truncateText = (text, maxLength = 40) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  if (loading) {
    return <div className="table-loading">Loading exhibitions...</div>;
  }

  if (!exhibitions || exhibitions.length === 0) {
    return (
      <div className="no-exhibitions">
        <p>No exhibitions found</p>
      </div>
    );
  }

  return (
    <div className="exhibition-table-container">
      <div className="table-responsive">
        <table className="exhibition-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Event Name</th>
              <th>Location</th>
              <th>Date</th>
              <th>Time</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {exhibitions.map((exhibition) => (
              <tr key={exhibition.event_id}>
                <td>{exhibition.event_id}</td>
                <td className="exhibition-name-cell">
                  <div className="exhibition-name">{truncateText(exhibition.event_name, 50)}</div>
                  {exhibition.event_caption && (
                    <div className="exhibition-caption">{truncateText(exhibition.event_caption, 60)}</div>
                  )}
                </td>
                <td>{truncateText(exhibition.event_location, 30) || 'N/A'}</td>
                <td>{formatDate(exhibition.event_date)}</td>
                <td>{formatTime(exhibition.event_time)}</td>
                <td>
                  <span className={`status-badge ${exhibition.status === 1 || exhibition.status === '1' ? 'active' : 'inactive'}`}>
                    {exhibition.status === 1 || exhibition.status === '1' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="actions-cell">
                  <button
                    className="btn btn-edit"
                    onClick={() => onEdit(exhibition.event_id)}
                    disabled={deletingId === exhibition.event_id}
                    title="Edit exhibition"
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-delete"
                    onClick={() => handleDelete(exhibition.event_id, exhibition.event_name)}
                    disabled={deletingId === exhibition.event_id}
                    title="Delete exhibition"
                  >
                    {deletingId === exhibition.event_id ? 'Deleting...' : 'Delete'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExhibitionTable;
